<div class="basic-profile" >
    <h3>{{consts.TITLE}}</h3>
    <mgt-person
        class="mgt-profile-avatar"
        person-query="me"
    >
    </mgt-person>
    <div class="name" *ngIf="employeeDetails || managerDetails">
        {{ddProfile?.preferred_first_name | defaultText: preferredName }} <br/>
        {{ddProfile?.worker_type | defaultText:'' }}
    </div>
    <div class="nav-menu">
        <a
            class="active"
            [class.active]="activeIndex === 0"
            (click)="showInformation('user')"
        >
            {{consts.MENU_WORKER_DETAILS}}
        </a>
        <a
            class="active"
            [class.active]="activeIndex === 1"
            (click)="showInformation('manager')"
        >
            {{consts.MENU_MANAGER_DETAILS}}
        </a>
        <a
            class="active"
            [class.active]="activeIndex === 2"
            (click)="showInformation('location')"
        >
            {{consts.MENU_LOCATION_DETAILS}}
        </a>
        <a
            class="active"
            [class.active]="activeIndex === 3"
            (click)="showInformation('profiles')"
        >
            {{consts.MENU_MY_PROFILES}}
        </a>
    </div>
</div>
<mat-icon
    svgIcon="hub_close"
    class="dialog-close-button"
    mat-dialog-close
>
</mat-icon>
<div class="profile-details" *ngIf="activeIndex === 0">
    <h4>{{consts.MENU_WORKER_DETAILS}}
        <a href="{{consts.EDIT_LINK}}"
            target="_blank">
            <mat-icon svgIcon="hub_editfile"></mat-icon>
            {{consts.LABEL_EDIT}}
        </a>
    </h4>
    <form>
        <label>
            {{consts.LABEL_FIRST_NAME}}
            <p>{{employeeDetails?.givenName || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_LAST_NAME}}
            <p>{{employeeDetails?.surname || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_EMP_ID}}
            <p>{{ddProfile?.personnel_number | defaultText }}</p>
        </label>
        <label>
           {{consts.LABEL_EMP_TYPE}}
           <p>{{ ddProfile?.worker_type | defaultText }}
            </p>
        </label>
        <label>
            {{consts.LABEL_EMAIL}}
            <p>{{employeeDetails?.mail || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_SHORT_NAME}}
            <p>{{employeeDetails?.mailNickname || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_JOB_TITLE}}
            <p>{{ddProfile?.job_title || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_JOB_FAMILY}}
            <p>{{ddProfile?.JB_FMLY_GRP_NM || consts.LABEL_NONE}}</p>
        </label>
    </form>
</div>
<div class="profile-details" *ngIf="activeIndex === 1">
    <h4>{{consts.MENU_MANAGER_DETAILS}}</h4>
    <form>
        <label>
            {{consts.LABEL_MANAGER_FULL_NAME}}
            <p>{{managerDetails?.displayName || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_MANAGER_ID}}
            <p>{{ddProfile?.manager_personnel_number | defaultText}}</p>
        </label>
        <label>
            {{consts.LABEL_MANAGER_EMAIL}}
            <p>{{managerDetails?.mail || consts.LABEL_NONE}}</p>
        </label>
    </form>
</div>
<div class="profile-details"  *ngIf="activeIndex === 2">
    <h4>{{consts.MENU_LOCATION_DETAILS}}
        <a href="{{consts.EDIT_LINK}}"
            target="_blank">
            <mat-icon svgIcon="hub_editfile"></mat-icon>
            {{consts.LABEL_EDIT}}
        </a>
    </h4>
    <form>
        <label>
            {{consts.LABEL_CENTER_NAME}}
            <p>{{ddProfile?.cost_center_name | defaultText}}</p>
        </label>
        <label>
            {{consts.LABEL_BUSINESS_UNIT}}
            <p>{{employeeDetails?.department || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_COUNTRY}}
            <p>{{employeeDetails?.country || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_REGION}}
            <p>{{ddProfile?.CORPORATE_REGION || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_LOCATION}}
            <p>{{employeeDetails?.usageLocation || consts.LABEL_NONE}}</p>
        </label>
        <label>
            {{consts.LABEL_TIMEZONE}}
            <p>{{timezone || consts.LABEL_NONE}}</p>
        </label>
    </form>
</div>
<div class="profile-details" *ngIf="activeIndex === 3">
    <h4>{{consts.MENU_MY_PROFILES}}</h4>
    <div class="profile-links">
        <a 
            *ngFor="let pl of profileLinks$ | async"
            href="{{pl.link}}"
            target="_blank"
        >
            {{pl.title}}
            <mat-icon svgIcon="hub_open_in_new"></mat-icon>
        </a>
    </div>
</div>
